import { calculateLevenshteinDistance } from './calculateLevenshteinDistance';

export function calculateTextSimilarity(a: string, b: string): number {
  const distance = calculateLevenshteinDistance(a, b);
  const maxLen = Math.max(a.length, b.length);
  return 1 - distance / maxLen;
}
